<template>
  <div class="imageUploadComp">

    <div
        class="div_image"
        @mouseenter="mouseEnter"
        @mouseleave="mouseLeave"
    >
        <image-uploader
            :preview="false"
            :className="['fileinput', { 'fileinput--loaded': imgSrc != '' }]"
            capture="environment"
            :debug="0"
            doNotResize="gif"
            :autoRotate="true"
            outputFormat="verbose"
            @input="setImage"
            @onUpload="onUpload"
            @onComplete="onComplete"
            accept=".jpg, .png"
        >
            <label for="fileInput" slot="upload-label">
                <div class="div_image_preview">
                    <img
                        slot="upload-label"
                        class="img_preview"
                        alt=""
                        :src="imgSrc"
                    >
                    <div
                        v-show="showIcon"
                        class="div_icon_image_preview"
                    >
                        <font-awesome-icon
                            :class="['icon_image_preview']"
                            :icon="`${imgSrc ? 'edit' : 'upload'}`"
                        />
                    </div>
                </div>

            </label>
        </image-uploader>
    </div>

  </div>
</template>

<script>

export default {
  name: 'imageUploadComp',
  props: {
    imgSrcProp: {
      type: String,
      default: function () { return '' }
    },
    setImgProp: Function,
    imgProp: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      image: null,
      icon: 'upload',
      showIcon: false,
      imgSrc: ''
    }
  },
  beforeCreate: function () {},
  created: function () {},
  watch: {
    imgSrcProp: function (v) {
      this.imgSrc = v
      this.setShowIcon()
    }
  },
  components: {},
  computed: {},
  methods: {
    mouseEnter: function () {
      this.showIcon = true
    },
    mouseLeave: function () {
      this.setShowIcon()
    },
    setShowIcon: function () {
      if (!this.imgSrc) this.showIcon = true
      else this.showIcon = false
    },
    setImage: function (output) {
      this.image = output
      this.imgSrc = this.image.dataUrl
      this.setShowIcon()
      this.setImgProp(this.image)
    },
    onUpload: function () {
      this.$store.dispatch('loadStart')
    },
    onComplete: function () {
      this.$store.dispatch('loadDone')
    }
  }
}
</script>

<style lang="scss">

#fileInput {
  display: none;
}

.imageUploadComp {
    width: 100%;
}
.div_image {
    border-radius: 10px;
    min-height: 100px;
}
.div_image_preview {
    position: relative;
    border-radius: 10px;
    min-height: 100px;
}
.img_preview {
    width: 100%;
    border-radius: 10px;
}
.div_icon_image_preview {
    background-color: #ff8200;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    border-radius: 10px;
}
.icon_image_preview {
    color: white;
    position:absolute;
    top: calc(50% - 8px);
    left: calc(50% - 8px);
}
.hide {
    display: none;
}

@media screen and (max-width: 1140px){}
@media screen and (max-width: 960px){}
@media screen and (max-width: 720px){}
@media screen and (max-width: 540px){}
@media screen and (max-width: 480px){}
@media screen and (max-width: 320px){}

</style>
